/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FunctionComponent } from 'react';
import { Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import CircularButton from '../../../../components/CircularButton/CircularButton';
import { Constants } from '../../../../utils';
import { paths } from '../../..';
import useStyles from './Information.styles';

interface IProps {
  title?: string;
  description?: string;
  testid: string;
}
const LINK_TEXT = {
  RESOURCES: 'resources',
};

const Information: FunctionComponent<IProps> = ({
  title,
  description = '',
  testid,
}) => {
  const classes = useStyles()
  const navigate = useNavigate();

  const navigateToLink = (event: React.SyntheticEvent | React.MouseEvent) => {
    event.preventDefault();
    if (event.target instanceof HTMLAnchorElement){
      const reference = event.target.href;
      const linkTo = reference.substr(reference.lastIndexOf('/') + 1);
      if (linkTo === LINK_TEXT.RESOURCES) {
        navigate(paths.resourcesDashboard);
      }
    }
  };

  return (
    <div className={classes.container}>
      <Typography
        variant="h2"
        className={classes.title}
        data-testid={`${testid}__information__title`}
      >
        {title}
      </Typography>
      <div onClick={navigateToLink}>
        <Typography
          className={classes.description}
          dangerouslySetInnerHTML={{ __html: description }}
          data-testid={`${testid}__information__description`}
        />
      </div>
      <Link
        to={paths.calculatorServiceData.replace(
          Constants.REPORT.URL_PARAM,
          Constants.REPORT.NEW
        )}
      >
        <CircularButton
          type="button"
          color="primary"
          variant="contained"
          customClass={classes.button}
          data-testid={`${testid}__information__button`}
        >
          Start the Calculator
        </CircularButton>
      </Link>
    </div>
  );
};

export default Information;
